"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchers = void 0;
var vektorioActions = require("@caddigital/sok-reducers/lib/actions/vektorio/connect");
var mapDispatchers = function (dispatch) { return ({
    toggleConnectProjects: function () { return dispatch(vektorioActions.toggleModal()); }
}); };
exports.mapDispatchers = mapDispatchers;
